import { useQuery } from '@tanstack/react-query';
import { getCenterReviewDashboard, getCoachReviewDashboard, getMemberReviewDetail, getMemberReviewList } from './api';
import { centerReviewKeys } from './keys';

export const useCenterReviewDashboard = ({
    centerId,

    enabled = true,
}: {
    centerId: string;

    enabled?: boolean;
}) =>
    useQuery({
        queryKey: centerReviewKeys.dashboard(centerId),
        queryFn: () => getCenterReviewDashboard({ centerId }),
        enabled: enabled && !!centerId,
        select: (data) => (data?.data as any).data,
    });

export const useCoachReviewDashboard = ({
    coachId,
    centerId,
    enabled = true,
}: {
    coachId: string;
    centerId?: string;
    enabled?: boolean;
}) =>
    useQuery({
        queryKey: centerReviewKeys.coachDashboard(coachId, centerId),
        queryFn: () => getCoachReviewDashboard({ coachId, centerId }),
        enabled: enabled && !!coachId,
        select: (data) => (data?.data as any).data,
    });

export const useMemberReviewDetail = ({ reviewId, enabled = true }: { reviewId: string; enabled?: boolean }) =>
    useQuery({
        queryKey: centerReviewKeys.memberReviewDetail(reviewId),
        queryFn: () => getMemberReviewDetail({ reviewId }),
        enabled: enabled && !!reviewId,
        select: (data) => (data?.data as any).data,
    });

export const useMemberReviewList = ({ centerId, enabled = true }: { centerId: string; enabled?: boolean }) =>
    useQuery({
        queryKey: centerReviewKeys.memberReviewList(centerId),
        queryFn: () => getMemberReviewList({ centerId }),
        enabled: enabled && !!centerId,
        select: (data) => (data?.data as any).data,
    });
